import type { RecipeCard } from "@shared/types/RecipeCard";

export enum CustomContentItemTypes {
  Banner = "banner",
  BrowseByBubble = "featured_content_browse_by",
  ContentBlock = "content_block",
  CollateralSection = "collateral_section",
  MiniStory = "featured_content_mini_story",
  ProductCarousel = "product_carousel",
  ProductCatalog = "product_catalog",
  ProductList = "product_list",
  RecipeCards = "recipe_cards",
  Spotlight = "spotlight",
  Title = "title",
  ActionBar = "action_bar",
}

export enum CustomContentFormTypes {
  AddSection = "add_section",
}

export type ValidCustomContentFormKeys = CustomContentItemTypes | CustomContentFormTypes;

export interface CustomContentItem {
  id?: number;
  position: number;
  item_type: CustomContentItemTypes;
  delete?: boolean;
}

export interface CustomContentTitle extends CustomContentItem {
  title_text?: string;
  description?: string;
  display_sponsored_label?: boolean;
}

export interface CustomContentProductCatalog extends CustomContentItem {
  title?: string;
  base_state_param_type?: string;
  base_state_param_id?: number;
  base_state_param_name?: string;
  uses_sponsors_for_base_state?: boolean;
}

export interface CustomContentBanner extends CustomContentItem {
  image_alt_text?: string;
  desktop_image_upload_id?: number;
  desktop_image_upload_url?: string;
  desktop_slot_id?: string;
  mobile_image_upload_id?: number;
  mobile_image_upload_url?: string;
  mobile_slot_id?: string;
  forward_url?: string;
  display_sponsored_label?: boolean;
}

export enum CustomContentProductListLayoutTypes {
  Grid = "grid",
  List = "list",
}
export interface CustomContentProductList extends CustomContentItem {
  title_text?: string;
  layout?: CustomContentProductListLayoutTypes;
  product_line_ids?: number[];
}

export interface CustomContentProductCarousel extends CustomContentItem {
  title_text?: string;
  product_line_ids?: number[];
}

export interface CustomContentSpotlight extends CustomContentItem {
  image_alt_text?: string;
  image_upload_id?: number;
  image_upload_url?: string;
  video_upload_id?: number;
  video_upload_url?: string;
  use_thumbnail?: boolean;
  title?: string;
  description?: string;
  forward_text?: string;
  forward_url?: string;

  hasButton?: boolean;
}
export interface CustomContentCollateralSection extends CustomContentItem {
  collaterals_attributes?: CustomContentCollateral[];
}
export interface CustomContentRecipeSection extends CustomContentItem {
  recipe_cards_attributes?: RecipeCard[];
}

export interface CustomContentContentBlock extends CustomContentItem {
  title?: string;
  description?: string;
  forward_url?: string;
  image_alt_text?: string;
  image_left_aligned?: boolean;
  image_upload_id?: number;
  image_upload_url?: string;
  highlights_attributes?: CustomContentContentBlockHighlight[];
  collaterals_attributes?: CustomContentCollateral[];
}

export interface CustomContentContentBlockHighlight {
  id?: number;
  position: number;
  highlight_text: string;
  _destroy?: boolean;
}

export interface CustomContentCollateral {
  id?: number;
  position: number;
  display_name: string;
  custom_content_collateral_upload_id?: number;
  filename?: string;
  _destroy?: boolean;
}

export interface CustomContentMiniStory extends CustomContentItem {
  image_alt_text?: string;
  image_upload_id?: number;
  image_upload_url?: string;
  video_upload_id?: number;
  video_upload_url?: string;
  use_thumbnail?: boolean;
  title?: string;
  description?: string;
  forward_url?: string;
  display_sponsored_label?: boolean;
}

export interface CustomContentBrowseByBubble extends CustomContentItem {
  image_alt_text?: string;
  image_upload_id?: number;
  image_upload_url?: string;
}

export interface CustomContentConfigrationResponse {
  id: number;
  custom_content_type: string;
  custom_content_items_updated_at: string;
  custom_content_items: (CustomContentTitle | CustomContentBanner | CustomContentProductList)[];
}

export interface LocalCustomContentConfiguration {
  custom_content_type: string;
  custom_content_items: CustomContentItem[];
  custom_content_items_updated_at: string;
}

export interface LocalCustomContentConfigurations {
  [id: number]: LocalCustomContentConfiguration;
}

export interface CustomContentItemTemplates {
  [key: string]: CustomContentItem;
}

export interface CustomContentActionBar extends CustomContentItem {
  image_url?: string;
  description: string;
}
